
import React from "react"
import { MeshTransmissionMaterial, useGLTF } from "@react-three/drei"
import { useLoader } from "@react-three/fiber"
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader'
import dancing from "../assets/environments/dancing_hall_1k.hdr";
export function Pds(props) {
  const { nodes, materials } = useGLTF("/PDSLogo.glb")
  const texture = useLoader(RGBELoader, dancing)
  const config = {
    backside: false,
    samples: 16,
    resolution: 512,
    transmission: 0.8,
    clearcoat: 0.42,
    clearcoatRoughness: 0.34,
    thickness: 5,
    chromaticAberration: 0,
    anisotropy: 0.3,
    roughness: 0,
    distortion: .89,
    distortionScale: 0.39,
    temporalDistortion: 0.2,
    ior: 1.61,
    color: '#bead80',
    gColor: '#44615d',
    shadow: '#bead80',
  }

  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Intro.geometry}
        material={nodes.Intro.material}
      >

        <MeshTransmissionMaterial reflectivity={0.5} {...config} background={texture} />
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Logo.geometry}
        material={nodes.Logo.material}
      >

        <MeshTransmissionMaterial reflectivity={0.5} {...config} background={texture} />
      </mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Circle.geometry}
        material={nodes.Circle.material}
      >

        <MeshTransmissionMaterial reflectivity={0.5} {...config} background={texture} />
      </mesh>
    </group>
  );
}

useGLTF.preload("/PDSLogo.glb")